module.exports = __webpack_public_path__ + "static/media/leandro_paredes.af692a64.jpg";